import { Box, styled, Typography } from '@mui/material';

export const OverlayRow = styled(Box)(({ theme }) => ({
    display: 'flex',
    width: 'fit-content',
    ...theme.mixins.glassOverlay,
    padding: theme.spacing(0.5),
    borderRadius: `${theme.shape.borderRadius}px`,
    gap: theme.spacing(0.75),
}));

/** The overlay readout's type, for anything that must line up with a label. */
const OVERLAY_LABEL_SX = {
    fontSize: 11,
    lineHeight: '11px',
    display: 'flex',
    alignItems: 'center',
    fontVariantNumeric: 'tabular-nums',
    fontFamily: 'Roboto Mono',
} as const;

export const OverlayLabel = styled(Typography)(OVERLAY_LABEL_SX);
